import { useNavigate, useSearch } from "@tanstack/react-router";
import { PackagePlus } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useProductActivationsQuery } from "@/api/query-hooks";
import { EmptyState, ErrorState, LoadingState } from "@/components/layout/route-states";
import { ClientScopePicker } from "@/features/licensing/client-scope";
import { ProductActivationTable } from "@/features/licensing/product-activation-table";

export function ProductActivationsPage() {
  const { t } = useTranslation(["licensing", "common"]);
  const navigate = useNavigate({ from: "/product-activations" });
  const search = useSearch({ from: "/product-activations" });
  const params = new URLSearchParams({ status: "PENDING" });
  if (search.clientId) params.set("clientId", String(search.clientId));
  const query = useProductActivationsQuery(params);

  if (query.isLoading) return <LoadingState />;
  if (query.isError) return <ErrorState title={t("common:states.error")} detail={query.error.message} onRetry={() => void query.refetch()} />;
  const items = query.data?.items ?? [];

  return (
    <div className="grid gap-4">
      <div>
        <h2 className="flex items-center gap-2 text-lg font-semibold"><PackagePlus className="h-5 w-5" />{t("queue.title")}</h2>
        <p className="mt-1 max-w-3xl text-sm text-muted-foreground">{t("queue.description")}</p>
      </div>
      <section className="rounded-md border bg-panel p-3">
        <ClientScopePicker value={search.clientId} required={false} onChange={(clientId) => void navigate({ search: { clientId } })} />
      </section>
      {items.length === 0 ? (
        <EmptyState title={t("queue.empty")} detail={t("queue.emptyDescription")} />
      ) : (
        <section className="overflow-hidden rounded-md border bg-panel"><ProductActivationTable items={items} /></section>
      )}
    </div>
  );
}
